import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const SettingsIcon = createSvgIcon(
  <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 2.45312L13 2.45312" stroke="currentColor" />
    <path
      d="M9.5 0.90625C8.94772 0.90625 8.5 1.35397 8.5 1.90625L8.5 2.90625C8.5 3.45854 8.94772 3.90625 9.5 3.90625C10.0523 3.90625 10.5 3.45854 10.5 2.90625L10.5 1.90625C10.5 1.35396 10.0523 0.90625 9.5 0.90625Z"
      fill="#F5F5F5"
      stroke="currentColor"
    />
    <path d="M13 9.45312L5.96046e-07 9.45312" stroke="currentColor" />
    <path
      d="M3.5 7.90625C4.05228 7.90625 4.5 8.35397 4.5 8.90625L4.5 9.90625C4.5 10.4585 4.05228 10.9063 3.5 10.9063C2.94772 10.9063 2.5 10.4585 2.5 9.90625L2.5 8.90625C2.5 8.35396 2.94772 7.90625 3.5 7.90625Z"
      fill="#F5F5F5"
      stroke="currentColor"
    />
  </svg>,
  'settings'
);
